const mapIcons =  {"txt": "<i class='fa fa-file-word-o text-blue text-bold mr-1 ng-star-inserted'></i>&nbsp",
"pdf": "<i class='fa fa-file-pdf-o text-red text-bold mr-1 ng-star-inserted'></i>&nbsp",
"cs":"<i class='fa fa-file-pdf-o text-red text-bold mr-1 ng-star-inserted'></i>&nbsp",
"xlsx":"<i class='fa fa-file-pdf-o text-red text-bold mr-1 ng-star-inserted'></i>&nbsp",
"png":"<i class='fa fa-file-pdf-o text-red text-bold mr-1 ng-star-inserted'></i>&nbsp"};

export default mapIcons;